import Vue from "vue";

export default {
  handleSizeChangeMyAppraiser({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getMyAppraisals");
  },
  handleCurrentChangeMyAppraiser({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getMyAppraisals");
  },

  getMyAppraisals({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(payload && payload),
      };

      Vue.$http
        .get("/hrm/appraisals/self-appraisables", { params })
        .then(response => {
          commit("myAppraisals", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getGeneralSettings");
  },
  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getGeneralSettings");
  },
  getAppraisalsAppraisalById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/appraisals/self-appraisable/${id}`)
        .then(response => {
          commit("appraisalsById", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  employeeSelfRating(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/appraisals/self-ratings`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  // Approval Appraisal
  handleSizeChangeAppraiserApproval({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getAppraisalsApproval");
  },
  handleCurrentChangeAppraiserApproval({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getAppraisalsApproval");
  },

  getAppraisalsApproval({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };

      Vue.$http
        .get("/hrm/appraisals/approvals", { params })
        .then(response => {
          commit("appraisalApproval", response.data.results);
          commit("paginationTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  approveAppraisalsApproval(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/appraisals/approve`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  rejectAppraisalsApproval(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/appraisals/reject`, payload)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
};
